module.exports = __webpack_public_path__ + "media/images/auth_1-d78cbbfdfef9ed1d357c687f09e67f62.jpg";